import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getApiLogs,
  getParticularPage,
  getNext,
  getPrevious,
  // filter by apiLogs id
  getSpecificApiLogs,
  handleSearch,
} from "./thunk";

const initialState = {
  apiLogs: [],
  edit: false,
  apiLog: null,
  count: null,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingUpdated: false,
  loadingApiLogs: false,
  loadingNext: false,
  loadingSpecific: false,
  showCreateModal: false,
};

export const apiLogsSlice = createSlice({
  name: "apiLogs",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    clearAllApiLogs: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingApiLogs = false;
      state.apiLog = null;
      state.loadingSpecific = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getSpecificApiLogs.pending, (state) => {
      state.apiLog = null;
      state.edit = false;
      state.loadingSpecific = true;
    });
    builder.addCase(getSpecificApiLogs.fulfilled, (state, action) => {
      state.apiLog = action.payload.data;
      state.edit = true;
      state.loadingSpecific = false;
    });

    builder.addCase(getSpecificApiLogs.rejected, (state) => {
      state.apiLog = null;
      state.edit = false;
      state.loadingSpecific = false;
    });

    builder.addMatcher(
      isAnyOf(
        getApiLogs.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingApiLogs = true;
      }
    );

    builder.addMatcher(
      isAnyOf(
        getApiLogs.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingApiLogs = false;
        state.apiLogs = action.payload.data;
        state.count = action.payload.totalCount;
        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getApiLogs.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingApiLogs = false;
      }
    );
  },
});

export const { setShowCreateModal, goToPage, clearAllApiLogs } = apiLogsSlice.actions;

export default apiLogsSlice.reducer;
